import React from 'react';
import Card from '../../../components/Card';
import Label from '../../../components/Label';
import classNames from 'classnames';
import { useBranding } from 'src/branding/BrandingContextProvider';
import { serviceRequestAgeEnum } from 'src/services/api/ServiceRequestDashboard/serviceRequestDashboard';
import { selectFilters } from 'src/store/selectors/serviceRequestDashboard/filters';
import { useDispatch, useSelector } from 'react-redux';
import { applyFilter } from 'src/store/actions/serviceRequestDashboard/filters';
import { IDashboardAgeOverview } from 'src/services/api/ServiceRequestDashboard/apiContracts';

const label = (serviceRequestOverview) => [
  {
    color: 'red',
    label: '60+ days old',
    value: serviceRequestAgeEnum.olderThan60Days,
    count: serviceRequestOverview?.days60PlusCount ?? 0,
  },
  {
    color: 'yellow',
    label: '30-60 days old',
    value: serviceRequestAgeEnum.between30And60Days,
    count: serviceRequestOverview?.days30_60Count ?? 0,
  },
  {
    color: 'teal',
    label: '<30 days old',
    value: serviceRequestAgeEnum.daysLessThan30,
    count: serviceRequestOverview?.daysLessThan30 ?? 0,
  },
];

const toggleState = (state: any, newValue: any) =>
  state === newValue ? null : newValue;

interface IDaysSinceSubmissionCardProps {
  serviceRequestOverview: IDashboardAgeOverview;
}

const DaysSinceSubmissionCard = ({
  serviceRequestOverview,
}: IDaysSinceSubmissionCardProps) => {
  const { branding, isBranded } = useBranding();
  const { selectedDate } = useSelector(selectFilters);
  const dispatch = useDispatch();

  const onSelectDate = (date) => {
    dispatch(applyFilter('selectedDate', toggleState(selectedDate, date)));
  };

  return (
    <Card
      title="Days Since Submission"
      body={
        <>
          {label(serviceRequestOverview).map((label, x) => (
            <div
              style={{ cursor: 'pointer' }}
              key={x}
              className={classNames('card__item', {
                card__item__dotted: selectedDate === label.value,
              })}
              onClick={() => onSelectDate(label.value)}
            >
              <Label color={label.color} label={label.label} />
              <div
                className="card__count"
                style={{
                  color: isBranded ? branding.colours.text.emphasis : undefined,
                }}
              >
                {label.count}
              </div>
            </div>
          ))}
        </>
      }
    />
  );
};

export default DaysSinceSubmissionCard;
